import React, { Component } from 'react';
import Constants from '../../Config/Config';
import Parser from 'html-react-parser';

class Glass extends Component {

  constructor(props) {
    super(props);
    this.getSelectedGlass = this.getSelectedGlass.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedGlass !== this.props.selectedGlass || prevProps.windowsFullDimension !== this.props.windowsFullDimension || prevProps.matsUpdated !== this.props.matsUpdated ) {
      this.getSelectedGlass();
  	}
	}

  getSelectedGlass = () => {
   	const {glasses, selectedGlass, selectedMatSize, windowsFullDimension} = this.props;

    let middleMatWidth = 0;

    if (parseFloat(selectedMatSize) === 2)
      middleMatWidth = this.props.middleMatGapInCM

		if (glasses.size > 0 && selectedGlass !== null) {
			glasses.filter( ( glass ) =>
        parseFloat(selectedGlass) === glass.get('id')
      ).map( ( glass ) =>
    		this.props.dispatch({
  				type: 'SET_STATE',
  				state: {
  					glassTotal: ( parseFloat(glass.getIn(['acf', 'price'])) * ( windowsFullDimension + (parseFloat(middleMatWidth) * 4) ) ).toFixed(2),
  					selectedGlassName: glass.getIn(['title', 'rendered'])
  				}
  			})
      )
    }
  };

	render() {
		const {glassTotal, selectedGlassName} = this.props;
    return (
      <tr>
  			<th>Glass</th>
  			<td>{selectedGlassName !== null ? Parser(selectedGlassName) : ''}</td>
  			<td>{Constants.Currency + glassTotal}</td>
      </tr>
    );
	}
}

export default Glass;